import {useContext, useEffect} from "react"
import { ProductContext } from "../contexts"
import { useFormContext, useWatch, Controller } from "react-hook-form"
import { DetailFormType } from "../../../utils"
import { Input } from "components"

export function Description() {
  const { data } = useContext(ProductContext)
  const { control, setValue, getValues, setError, clearErrors} = useFormContext<DetailFormType>()
  const product_id = useWatch({ control, name: "product_id" })

  useEffect(() => {    
    const currentDescription = getValues("description")
    
    if (currentDescription == null || currentDescription === "") {
      const defaultDesc = data.find(item => item.value === product_id)?.vendor_description || ""
      setValue("description", defaultDesc)
    }

    const quantity_unit_convention = data.find(item => item.value === product_id)?.quantity_unit_convention
    setValue("quantity_unit_convention", quantity_unit_convention)
  }, [product_id, data, setValue, getValues])

  return (
    <Controller
      control={control}
      name="description"
      render={({ field, fieldState }) => (
        <Input
          error={fieldState.error?.message}
          ref={field.ref}
          value={field.value}
          onChange={(e) => {
            const val = e.target.value
            field.onChange(val)
        
            if (val === "") {
              setError("description", {
                type: "manual",
                message: "Description is required"
              })
            } else {
              clearErrors("description") // hapus error kalau valid
            }
          }}
        />
      )}
    />
  )
}